var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":"","large":"","color":"#1D3557","dark":""},on:{"click":_vm.reloadConversations}},'v-btn',attrs,false),on),[_c('icon',{attrs:{"icon":"sync-alt"}})],1)]}}])},[_c('span',[_vm._v("Reload Conversations")])])
}
var staticRenderFns = []

export { render, staticRenderFns }